export const getCurrentPath = (routes: string[] | undefined) => {
  if (typeof window !== "undefined") {
    if (routes && window.next) {
      const router = window?.next?.router;
      return routes.includes(`${router?.basePath}${router?.state?.route}`);
    }
  } else {
    return "";
  }
};
